import Phaser from "phaser";
import ImageHelpers from "./ImageHelpers";
import { IActiveSkill } from "../Skills/ISkill";

export default class SkillButtonGUI {
  private mButton: Phaser.GameObjects.Image;
  private mKeyText: Phaser.GameObjects.Text;
  private mCooldownOverlay: Phaser.GameObjects.Graphics;
  private mCooldownText: Phaser.GameObjects.Text;
  private mScene: Phaser.Scene;

  constructor(
    scene: Phaser.Scene,
    skill: IActiveSkill,
    x: number,
    y: number,
    keyLabel: string,
    onActivate: () => void,
    size: number = 48
  ) {
    this.mScene = scene;

    this.mButton = scene.add
      .image(x, y, skill.IconKey)
      .setOrigin(0.5, 1)
      .setInteractive({ useHandCursor: true })
      .setDisplaySize(size, size);

    this.mButton.on("pointerdown", () => {
      onActivate();
    });

    ImageHelpers.SetHoverEffectOnImage(scene, this.mButton);

    const btnHalfW = this.mButton.displayWidth / 2;
    const keyX = x + btnHalfW - 3;   // right edge of button minus padding
    const keyY = y - 3;               // bottom edge of button minus padding
    this.mKeyText = scene.add
      .text(keyX, keyY, keyLabel, {
        fontFamily: "monospace",
        fontSize: "13px",
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 3,
      })
      .setOrigin(1, 1);

    this.mCooldownOverlay = scene.add.graphics();
    this.mCooldownText = scene.add
      .text(x, y - size / 2, "", {
        fontFamily: "monospace",
        fontSize: "16px",
        color: "#ffffff",
      })
      .setOrigin(0.5, 0.5);
  }

  public UpdateCooldown(
    cooldownRemaining: number,
    totalCooldown: number
  ): void {
    this.mCooldownOverlay.clear();
    if (cooldownRemaining > 0) {
      const ratio = cooldownRemaining / totalCooldown;
      this.mCooldownOverlay.fillStyle(0x000000, 0.5);
      const h = this.mButton.displayHeight * ratio;
      this.mCooldownOverlay.fillRect(
        this.mButton.x - this.mButton.displayWidth / 2,
        this.mButton.y - h,
        this.mButton.displayWidth,
        h
      );
      this.mCooldownText.setText(`${(cooldownRemaining / 1000).toFixed(1)}s`);
      this.mButton.setTint(0x888888);
    } else {
      this.mCooldownText.setText("");
      this.mButton.clearTint();
    }
  }

  public destroy(): void {
    this.mButton.removeAllListeners();
    this.mButton.destroy();
    this.mKeyText.destroy();
    this.mCooldownOverlay.destroy();
    this.mCooldownText.destroy();
  }
}
